import { getFeatureFlagsProperties } from '@pflegia/feature-flags/utils/helpers/get-feature-flag-properties';
import { FunnelQuestionCategory } from '@pflegia/types/api/funnel/questions';
import { RegisterMethod } from '@pflegia/types/common/enums/register-method.enum';

import { segmentService } from '../analytics/segment.service';

const FunnelQuestionCategoryToMarketingCategory = {
  [FunnelQuestionCategory.Field]: 'Nursing Area',
};

const categoryMarketingTransform = (category: FunnelQuestionCategory) =>
  category === FunnelQuestionCategory.Field ? FunnelQuestionCategoryToMarketingCategory[category] : category;

// TODO: Refactor https://pflegia.atlassian.net/browse/PFLG-7318
export const trackEventRegistration = (
  eventName: string,
  registerMethod: RegisterMethod,
  eventProperties?: Record<string, unknown>,
  questionId?: string,
  questionCategory?: FunnelQuestionCategory,
) =>
  segmentService.trackQuestionAnswers(eventName, {
    question: {
      id: questionId,
      category: questionCategory,
      transformer: category => categoryMarketingTransform(category as unknown as FunnelQuestionCategory),
    },
    ...eventProperties,
    ...getFeatureFlagsProperties(),
    funnel: registerMethod,
  });
